import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const cas = [
  "Tablier trop abîmé avec lames tordues, perforées ou corrodées",
  "Mécanisme de plus de 25 ans avec pièces introuvables",
  "Réparations répétitives qui dépassent le seuil économique",
  "Coffre endommagé ou neuf non isolé, source de déperdition thermique",
  "Envie de passer au motorisé avec un coffre adapté",
  "Changement d'esthétique : couleur, matériau ou style de lame",
];

export default function RemplacerReparer() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border order-2 lg:order-1">
            <ImagePlaceholder
              src="https://readdy.ai/api/search-image?query=Before%20and%20after%20comparison%20of%20an%20old%20damaged%20roller%20shutter%20versus%20a%20brand%20new%20white%20roller%20shutter%20on%20a%20French%20house%20window%20professional%20renovation%20service%20photography%20clean%20daylight%20warm%20neutral%20tones%20Alsace%20region&width=700&height=520&seq=pose-avantapres&orientation=landscape"
              alt="Comparaison entre un volet roulant abîmé et un volet neuf à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Quand remplacer plutôt que réparer ?
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-4">
              Dans la plupart des cas, la réparation est suffisante et plus économique. Mais il arrive que le remplacement soit la meilleure option, surtout lorsque le volet est très ancien ou le tablier trop endommagé. Si vous avez déjà fait réparer plusieurs fois le même volet, ou si les pièces de rechange n&apos;existent plus, un remplacement complet peut vous faire gagner du temps et de l&apos;argent sur le long terme.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Un vieux coffre non isolé peut aussi être une source de déperdition thermique importante. En remplaçant par un coffre moderne avec un tablier isolé, vous améliorez le confort de votre logement et réduisez votre facture énergétique. Nos techniciens vous conseillent avec honnêteté : si la réparation suffit, nous la privilégions. Si le remplacement est pertinent, nous vous proposons une solution adaptée à votre budget.
            </p>
            <div className="space-y-3">
              {cas.map((c) => (
                <div key={c} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-lg"></i>
                  </div>
                  <p className="text-brand-text text-sm leading-relaxed">{c}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}